import React, { memo, useMemo } from 'react';
import FilterBar from '../common/FilterBar';
import SearchableSelect from '../common/SearchableSelect';
import { Center, Class, Subject } from './types';

interface QuestionBankFiltersProps {
  isSystemAdmin: boolean;
  centers: Center[];
  classes: Class[];
  subjects: Subject[];
  selectedCenter: string;
  selectedClass: string;
  selectedSubject: string;
  onCenterChange: (value: string) => void;
  onClassChange: (value: string) => void;
  onSubjectChange: (value: string) => void;
}

const toOptions = (rows: Array<{ _id: string; name: string }>) => rows.map((r) => ({ value: r._id, label: r.name }));

/** Class and subject: narrows the bank list, and opens a bank once both are picked. */
const QuestionBankFilters = memo<QuestionBankFiltersProps>(({
  isSystemAdmin,
  centers,
  classes,
  subjects,
  selectedCenter,
  selectedClass,
  selectedSubject,
  onCenterChange,
  onClassChange,
  onSubjectChange,
}) => {
  const centerOptions = useMemo(() => toOptions(centers), [centers]);
  const classOptions = useMemo(() => toOptions(classes), [classes]);
  const subjectOptions = useMemo(() => toOptions(subjects), [subjects]);

  return (
    <FilterBar>
      {isSystemAdmin && (
        <SearchableSelect label="Center" placeholder="All centers" value={selectedCenter} onChange={onCenterChange} options={centerOptions} minWidth={200} />
      )}
      <SearchableSelect label="Class" placeholder="All classes" value={selectedClass} onChange={onClassChange} options={classOptions} minWidth={180} />
      <SearchableSelect
        label="Subject"
        placeholder={selectedClass ? 'All subjects' : 'Pick a class first'}
        value={selectedSubject}
        onChange={onSubjectChange}
        options={subjectOptions}
        disabled={!selectedClass}
        minWidth={200}
      />
    </FilterBar>
  );
});

QuestionBankFilters.displayName = 'QuestionBankFilters';

export default QuestionBankFilters;
